export const configuracionColumnasMorosidades = [
    {
        name: "acreedor",
        field: "acreedor",
        label: "Acreedor",
        align: "left",
    },
    {
        name: "por_vencer",
        field: "por_vencer",
        label: "Por vencer",
        align: "left",
    },
    {
        name: "no_devenga_intereses",
        field: "no_devenga_intereses",
        label: "No devenga intereses",
        align: "left",
    },
    {
        name: "vencido",
        field: "vencido",
        label: "Vencido",
        align: "left",
    },
    {
        name: "saldo_deuda",
        field: "saldo_deuda",
        label: "Saldo deuda",
        align: "left",
    },
];
